import basePath from "base_path";

import ActionTypes, {ClientContextActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ClientContext} from "common/types/client_context";

export type ClientContextCreateAction = {
  type: ClientContextActionTypes["CLIENT_CONTEXT_CREATE"]["SUCCESS"];
  payload: ClientContext;
};

export default function createClientContext(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLIENT_CONTEXT_CREATE,
    (organisationId: OrganisationId, name: string, context: string) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/client_context`,
          {name, context},
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
